var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-dialog-scrollable modal-xl",
        attrs: { role: "document" }
      },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h4",
              { staticClass: "modal-title" },
              [
                _c("i", { staticClass: "fa fa-gear" }),
                _vm._v(" "),
                _vm._t("editModalTitle", function() {
                  return [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("group.editModal.title.editGroup")) +
                        "\n          "
                    )
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _vm.group
            ? _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("GroupEditor", {
                    ref: "groupEditor",
                    attrs: {
                      allUsers: _vm.allUsers,
                      availableSalutations: _vm.availableSalutations,
                      group: _vm.group,
                      groupSelector: _vm.groupSelector,
                      groupCopyFunction: _vm.groupCopyFunction,
                      groupSaveFunction: _vm.groupSaveFunction,
                      hiddenTabs: _vm.hiddenTabs,
                      tabTitles: _vm.tabTitles,
                      hidePinned: _vm.hidePinned,
                      hideExternalUserDisabled: _vm.hideExternalUserDisabled,
                      hideMassSelection: _vm.hideMassSelection,
                      allowNoEmailForExternalUsers:
                        _vm.allowNoEmailForExternalUsers
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "generalAfter",
                          fn: function({ group }) {
                            return [
                              _vm._t("generalAfter", null, { group: group })
                            ]
                          }
                        },
                        {
                          key: "userButtonsBefore",
                          fn: function({ groupUser }) {
                            return [
                              _vm._t("userButtonsBefore", null, {
                                groupUser: groupUser
                              })
                            ]
                          }
                        },
                        {
                          key: "userButtonsAfter",
                          fn: function({ groupUser }) {
                            return [
                              _vm._t("userButtonsAfter", null, {
                                groupUser: groupUser
                              })
                            ]
                          }
                        },
                        {
                          key: "externalUserButtonsBefore",
                          fn: function({ groupUserExternal }) {
                            return [
                              _vm._t("externalUserButtonsBefore", null, {
                                groupUserExternal: groupUserExternal
                              })
                            ]
                          }
                        },
                        {
                          key: "externalUserButtonsAfter",
                          fn: function({ groupUserExternal }) {
                            return [
                              _vm._t("externalUserButtonsAfter", null, {
                                groupUserExternal: groupUserExternal
                              })
                            ]
                          }
                        },
                        {
                          key: "selectedExternalUserButtonsBefore",
                          fn: function({ groupUserExternals }) {
                            return [
                              _vm._t(
                                "selectedExternalUserButtonsBefore",
                                null,
                                { groupUserExternals: groupUserExternals }
                              )
                            ]
                          }
                        },
                        {
                          key: "selectedExternalUserButtonsAfter",
                          fn: function({ groupUserExternals }) {
                            return [
                              _vm._t("selectedExternalUserButtonsAfter", null, {
                                groupUserExternals: groupUserExternals
                              })
                            ]
                          }
                        },
                        {
                          key: "externalUserSelectModalTabs",
                          fn: function() {
                            return [_vm._t("externalUserSelectModalTabs")]
                          },
                          proxy: true
                        },
                        {
                          key: "editModalTabs",
                          fn: function({ group }) {
                            return [
                              _vm._t("editModalTabs", null, { group: group })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: _vm.saving },
                on: { click: _vm.onSave }
              },
              [
                _c("Spinner", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.saving,
                      expression: "saving"
                    }
                  ],
                  attrs: { small: true }
                }),
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                )
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }